import { readableDate } from '@occc-app/lib/format';
import { DateTimeFormat } from '@occc-app/lib/date';
import { InfoField } from '@occc/ui-design-system';
import { ScheduleBlocksVisibility } from '@occc-app/offerHelpers/ScheduleForm/utils';
import { formatYesNoValues } from '../formatters';
import { arrangeNodeGroups, renderNodeGroups } from '../utils';
import { SectionCard } from '../../components';
import { BLOCKS_IN_ROW } from '../constants';

type ScheduleSectionProps = {
  publishAt: string | null;
  expireAt: string | null;
  timezone: string;
  isTriggeredOnVisibility?: boolean | null;
  isTriggeredOnFulfillment?: boolean | null;
  isTriggeredOnProgress?: boolean | null;
  triggeredOnVisibilityMessage?: string | null;
  triggeredOnFulfillmentMessage?: string | null;
  triggeredOnProgressMessage?: string | null;
  visibleBlocks?: ScheduleBlocksVisibility;
};

export const ScheduleSection = ({
  publishAt,
  expireAt,
  timezone,
  isTriggeredOnVisibility,
  isTriggeredOnFulfillment,
  isTriggeredOnProgress,
  triggeredOnVisibilityMessage,
  triggeredOnFulfillmentMessage,
  triggeredOnProgressMessage,
  visibleBlocks,
}: ScheduleSectionProps) => {
  const blockGroups = arrangeNodeGroups(
    [
      visibleBlocks?.Dates && [
        <InfoField
          label='Offer Available From'
          value={publishAt && readableDate(publishAt, DateTimeFormat.DateTime12h)}
        />,
        <InfoField
          label='Offer Available To'
          value={expireAt && readableDate(expireAt, DateTimeFormat.DateTime12h)}
        />,
        <InfoField label='Timezone' value={timezone} />,
      ],
      visibleBlocks?.TriggerOnVisibility && (
        <InfoField
          label='Message on Offer Available'
          value={
            triggeredOnVisibilityMessage
              ? triggeredOnVisibilityMessage
              : formatYesNoValues([isTriggeredOnVisibility])
          }
        />
      ),
      visibleBlocks?.TriggerOnFulfillment && (
        <InfoField
          label='Message on Offer Fulfillment'
          value={
            triggeredOnFulfillmentMessage
              ? triggeredOnFulfillmentMessage
              : formatYesNoValues([isTriggeredOnFulfillment])
          }
        />
      ),
      visibleBlocks?.TriggerOnProgress && (
        <InfoField
          label='Message on Offer in Progress'
          value={
            triggeredOnProgressMessage
              ? triggeredOnProgressMessage
              : formatYesNoValues([isTriggeredOnProgress])
          }
        />
      ),
    ],
    BLOCKS_IN_ROW,
  );

  return blockGroups.length ? (
    <SectionCard title='Schedule'>{renderNodeGroups(blockGroups, BLOCKS_IN_ROW)}</SectionCard>
  ) : null;
};
